<template>
  <div v-if="isTransportPedestrian">
    <div class="row">
      <div class="col-md-6">
        <h5>
          Транспортное средство
          <span v-if="!transport.number" class="text-uppercase">№{{ transportIndex + 1 }}</span>
          <span v-else class="text-uppercase">{{ transport.number }}</span>
        </h5>
      </div>
      <transport-form-menu
        :transport-index="transportIndex"
        :visitor-personal="visitor.personal"
        :visitor-index="visitorIndex"
        :visitor="visitor"
        :form="form"
        :transport="transport"
        :cfg-menu-transport="cfgMenuTransport"
        :cfg-menu-visitor="cfgMenuVisitor"
        :menu-not-empty="transportFormMenuNotEmpty"
      />
      <div v-if="(isView === false || isDuplicate) && canRemoveTransport " class="col-md-6">
        <button
          type="button"
          style="margin-right: 0"
          class="btn btn-default pull-right delete-btn visitors-control-btn"
          @click="removeTransport"
        >Удалить</button>
      </div>
    </div>

    <div class="row">
      <div
        v-if="fieldVisible(TransportSectionFieldAliases.TYPE_INPUT, PassSectionsEnum.transport)"
        :class="'col-md-' + fieldWidth(TransportSectionFieldAliases.TYPE_INPUT, PassSectionsEnum.transport)"
      >
        <transport-type-input
          v-model="transport.type"
          :input-label="fieldTitle(TransportSectionFieldAliases.TYPE_INPUT, PassSectionsEnum.transport)"
          :input-hint="fieldHint(TransportSectionFieldAliases.TYPE_INPUT, PassSectionsEnum.transport)"
          :form="form"
          :transport-index="transportIndex"
          :transport="transport"
          :visitor-index="visitorIndex"
          :visitor="visitor"
          :transport-types="transportTypes"
          :disabled="disabledType"
          :errors="errors"
          @change="change; clearMark(); clearNumberPlateInput()"
        />
      </div>
      <div
        v-if="fieldVisible(TransportSectionFieldAliases.TYPE_FROM_STS_INPUT, PassSectionsEnum.transport)"
        :class="'col-md-' + fieldWidth(TransportSectionFieldAliases.TYPE_FROM_STS_INPUT, PassSectionsEnum.transport)"
      >
        <transport-type-from-sts-input
          v-model="transport.sts_type"
          :sts-types="sortedStsTypes"
          :form="form"
          :transport-index="transportIndex"
          :transport="transport"
          :visitor-index="visitorIndex"
          :visitor="visitor"
          :taggable="true"
          :disabled="disabledStsType"
          :errors="errors"
          @change="change"
        />
      </div>
      <div
        v-if="fieldVisible(TransportSectionFieldAliases.NUMBER_PLATE, PassSectionsEnum.transport)"
        :class="'col-md-' + fieldWidth(TransportSectionFieldAliases.NUMBER_PLATE, PassSectionsEnum.transport)"
      >
        <number-plate-input
          v-model="transport.number"
          :input-label="fieldTitle(TransportSectionFieldAliases.NUMBER_PLATE, PassSectionsEnum.transport)"
          :input-hint="fieldHint(TransportSectionFieldAliases.NUMBER_PLATE, PassSectionsEnum.transport)"
          :disabled="disabledNumber"
          :errors="errors"
          :form="form"
          :is-transport-number="true"
          :transport="transport"
          :transport-index="transportIndex"
          :transport-plate-masks="sortedTransportPlateMasks"
          :typeahead="typeaheadCarNumber"
          typeahead-item-key="number"
          :select-typeahead="selectTransportTypeahead"
          :selected-plate="transportPlateMask"
          :visitor="visitor"
          :visitor-index="visitorIndex"
          input-name="number"
          ref="transportPlate"
          @paste="removeRusInTransportNumber(false, $event)"
          @change="change"
          @change-plate="changeTransportNationality"
        >
          <div slot="after">
            <label class="applicant-helpers flex-label">
              <input
                v-model="transport.number_missing"
                :disabled="disabledInput"
                type="checkbox"
                @change="onChangeNumberFieldPresenceType"
              />
              &nbsp;
              Отсутствует
            </label>
          </div>
        </number-plate-input>
        <number-helpers-input
          v-show="!disabledNumberHelpers"
          :form="form"
          :disabled="disabledNumberHelpers"
          :transport="transport"
          :transport-index="transportIndex"
          :visitor="visitor"
          @set-transport="setTransport"
        />
      </div>
      <div
        v-if="fieldVisible(TransportSectionFieldAliases.NUMBER_PLATE_TRAILER, PassSectionsEnum.transport)"
        :class="'col-md-' + fieldWidth(TransportSectionFieldAliases.NUMBER_PLATE_TRAILER, PassSectionsEnum.transport)"
      >
        <number-plate-input
          v-model="transport.trailer"
          :input-label="fieldTitle(TransportSectionFieldAliases.NUMBER_PLATE_TRAILER, PassSectionsEnum.transport)"
          :input-hint="fieldHint(TransportSectionFieldAliases.NUMBER_PLATE_TRAILER, PassSectionsEnum.transport)"
          :disabled="disabledTrailer"
          :errors="errors"
          :form="form"
          :transport="transport"
          :transport-index="transportIndex"
          :transport-plate-masks="sortedTrailerPlateMasks"
          :selected-plate="trailerPlateMask"
          :visitor="visitor"
          :visitor-index="visitorIndex"
          input-name="trailer"
          ref="trailerPlate"
          @paste="removeRusInTransportNumber(true, $event)"
          @change="change"
          @change-plate="changeTrailerNationality"
        />
      </div>
    </div>
    <div class="row">
      <div
        v-if="fieldVisible(TransportSectionFieldAliases.MARK, PassSectionsEnum.transport)"
        :class="'col-md-' + fieldWidth(TransportSectionFieldAliases.MARK, PassSectionsEnum.transport)"
      >
        <transport-mark-input
          v-model="transport.mark"
          :input-label="fieldTitle(TransportSectionFieldAliases.MARK, PassSectionsEnum.transport)"
          :input-hint="fieldHint(TransportSectionFieldAliases.MARK, PassSectionsEnum.transport)"
          :form="form"
          :errors="errors"
          :transport-index="transportIndex"
          :transport="transport"
          :taggable="true"
          :visitor-index="visitorIndex"
          :visitor="visitor"
          :disabled="disabledMark"
          :marks="sortedMarks"
          @change="change"
        />
      </div>
      <div
        v-if="fieldVisible(TransportSectionFieldAliases.MODEL, PassSectionsEnum.transport)"
        :class="'col-md-' + fieldWidth(TransportSectionFieldAliases.MODEL, PassSectionsEnum.transport)"
      >
        <transport-model-input
          v-model="transport.model"
          :input-label="fieldTitle(TransportSectionFieldAliases.MODEL, PassSectionsEnum.transport)"
          :input-hint="fieldHint(TransportSectionFieldAliases.MODEL, PassSectionsEnum.transport)"
          :form="form"
          :errors="errors"
          :transport-index="transportIndex"
          :transport="transport"
          :taggable=true
          :visitor-index="visitorIndex"
          :visitor="visitor"
          :disabled="disabledModel"
          :models="sortedModels"
          @change="change"
        />
      </div>
      <div
        v-if="fieldVisible(TransportSectionFieldAliases.COLOR, PassSectionsEnum.transport)"
        :class="'col-md-' + fieldWidth(TransportSectionFieldAliases.COLOR, PassSectionsEnum.transport)"
      >
        <transport-color-input
          v-model="transport.color"
          :input-label="fieldTitle(TransportSectionFieldAliases.COLOR, PassSectionsEnum.transport)"
          :input-hint="fieldHint(TransportSectionFieldAliases.COLOR, PassSectionsEnum.transport)"
          :form="form"
          :errors="errors"
          :transport-index="transportIndex"
          :transport="transport"
          :taggable=true
          :visitor-index="visitorIndex"
          :visitor="visitor"
          :typeahead="typeaheadColor"
          :disabled="disabledColor"
          :colors="transportColors"
          @change="change"
        />
      </div>
    </div>
    <div class="row">
      <div
        v-if="fieldVisible(TransportSectionFieldAliases.OWNER, PassSectionsEnum.transport)"
        :class="'col-md-' + fieldWidth(TransportSectionFieldAliases.OWNER, PassSectionsEnum.transport)"
      >
        <transport-owner-input
          v-model="transport.owner"
          :input-label="fieldTitle(TransportSectionFieldAliases.OWNER, PassSectionsEnum.transport)"
          :input-hint="fieldHint(TransportSectionFieldAliases.OWNER, PassSectionsEnum.transport)"
          :form="form"
          :errors="errors"
          :transport-index="transportIndex"
          :transport="transport"
          :visitor-index="visitorIndex"
          :visitor="visitor"
          :disabled="disabledOwner"
          @change="change"
        />
      </div>
      <div
        v-if="fieldVisible(TransportSectionFieldAliases.USER_POSITION, PassSectionsEnum.transport)"
        :class="'col-md-' + fieldWidth(TransportSectionFieldAliases.USER_POSITION, PassSectionsEnum.transport)"
      >
        <transport-user-position-input
          v-model="transport.user_position"
          :input-label="fieldTitle(TransportSectionFieldAliases.USER_POSITION, PassSectionsEnum.transport)"
          :input-hint="fieldHint(TransportSectionFieldAliases.USER_POSITION, PassSectionsEnum.transport)"
          :form="form"
          :errors="errors"
          :transport-index="transportIndex"
          :transport="transport"
          :disabled="disabledUserInput"
          :visitor-index="visitorIndex"
          :visitor="visitor"
          @change="change"
        />
      </div>
    </div>
    <div class="row">
      <transport-documents-form-block
        :errors="errors"
        :form="form"
        :transport-documents="transportDocuments"
        :transport-index="transportIndex"
        :transport="transport"
        :visitor-index="visitorIndex"
        :visitor="visitor"
      />
    </div>
    <div v-if="isPassKindTransport" style="margin-top:35px">
      <div
        v-for="(visitor, visitorIndex) in transport.drivers"
        :id="transportDriverFormId(visitorIndex)"
        :key="visitorIndex"
        class="visitor-block"
      >
        <div>
          <visitor-personal-form-block
            v-model="visitor.personal"
            :form="form"
            :approve-form="approveForm"
            :can-scud="canScud"
            :errors="errors"
            :is-single-visitor="isSingleVisitor"
            :nationalities-list="personalNationalities"
            :organization-subjects-residency="organizationSubjectsResidency"
            :organization-subjects="organizationSubjectsWithoutFizAndTerminal"
            :visitor-index="visitorIndex"
            :visitor="visitor"
            :transport-index="transportIndex"
            :personal-nationalities="personalNationalities"
            :personal-identifications="personalIdentifications"
            :cfg-menu-visitor="cfgMenuVisitor"
            :cfg-form-fields="cfgFormFields"
            :document-masks="documentMasks"
            :typeaheads="typeaheads"
            :timezone="timezone"
            @change-visitor="change"
            @remove-visitor="removeVisitor"
            @disable-submit-button="$emit('disable-submit-button')"
            @enable-submit-button="$emit('enable-submit-button')"
            @change-date="$emit('change-date', $event)"
          />
          <visitor-documents-form-block
            v-if="isNotCutDriver"
            :form="form"
            :errors="errors"
            :visitor-index="visitorIndex"
            :transport-index="transportIndex"
            :visitor="visitor"
            :nationality-documents="nationalityDocuments"
            :personal-nationalities="personalNationalities"
            ref="visitorDocuments"
            @disable-submit-button="$emit('disable-submit-button')"
            @enable-submit-button="$emit('enable-submit-button')"
          />
        </div>
      </div>
      <div v-if="showAddDriverButton" class="text-center">
        <div id="form-visitors-transports-drivers-button" class="add-vew-visitor">
          <button
            type="button"
            class="btn btn-default btn-primary-white"
            @click="addVisitor()"
          >Добавить водителя</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import { ApplicationStatuses } from '@/enums/ApplicationStatuses'
import forceRerenderMixin from '@/common/mixins/forceRerenderMixin'
import mainMixin from '@/common/mixins/mainMixin'
import NumberHelpersInput from '@/common/components/application/form-inputs/transports/NumberHelpersInput'
import NumberPlateInput from '@/common/components/application/form-inputs/transports/NumberPlateInput'
import scudMixin from '@/common/mixins/scudMixin'
import { TerminalRegionActions } from '@/common/enums/TerminalRegionActions'
import TransportColorInput from '@/common/components/application/form-inputs/transports/TransportColorInput'
import TransportDocumentsFormBlock from './TransportDocumentsFormBlock'
import TransportFormMenu from '@/common/components/application/form-blocks/transports/TransportFormMenu'
import TransportMarkInput from '@/common/components/application/form-inputs/transports/TransportMarkInput'
import TransportModelInput from '@/common/components/application/form-inputs/transports/TransportModelInput'
import TransportOwnerInput from '@/common/components/application/form-inputs/transports/TransportOwnerInput'
import transportsBlockMixin from '@/common/mixins/application-form/transportsBlockMixin'
import TransportTypeInput from '@/common/components/application/form-inputs/transports/TransportTypeInput'
import TransportUserPositionInput from '@/common/components/application/form-inputs/transports/TransportUserPositionInput.vue'
import { Typeaheads } from '@/common/helpers/api-client/Typeaheads'
import { UserRoles } from '@/enums/UserRoles'
import VisitorDocumentsFormBlock from '@/common/components/application/form-blocks/visitors/VisitorDocumentsFormBlock.vue'
import VisitorPersonalFormBlock from '@/components/application/form-blocks/visitors/VisitorPersonalFormBlock.vue'
import { cloneObject } from '@/common/helpers'
import Visitor from '@/common/classes/Visitor'
import { PersonalIdentifications } from '@/common/enums/PersonalIdentifications'
import { TransportSectionFieldAliases } from '@/common/enums/ApplicationSectionFieldAliases'
import PassSectionsEnum from '@/common/enums/PassSectionsEnum'
import TransportTypeFromStsInput from '@/common/components/application/form-inputs/transports/TransportTypeFromStsInput.vue'
import TransportsFormBlock from '@/common/components/application/form-blocks/transports/TransportsFormBlock.vue';

export default {
  name: 'TransportInfoFormBlock',

  components: {
    TransportsFormBlock,
    TransportTypeFromStsInput,
    VisitorPersonalFormBlock,
    VisitorDocumentsFormBlock,
    TransportUserPositionInput,
    NumberHelpersInput,
    TransportDocumentsFormBlock,
    TransportTypeInput,
    TransportMarkInput,
    TransportModelInput,
    TransportColorInput,
    TransportOwnerInput,
    TransportFormMenu,
    NumberPlateInput
  },

  mixins: [
    mainMixin,
    applicationFormMixin,
    applicationFormContextMixin,
    forceRerenderMixin,
    transportsBlockMixin,
    scudMixin
  ],

  model: {
    prop: 'transport',
    event: 'change-transport'
  },

  props: {
    organizationSubjects: {
      type: Array,
      default: () => []
    },
    organizationSubjectsResidency: {
      default: []
    },
    cfgFormFields: {
      type: [Array, Object],
      default: () => []
    },

    cfgMenuVisitor: {
      type: [Object, Array],
      default: () => []
    },

    cfgMenuTransport: {
      type: [Object, Array],
      default: () => []
    },

    sortedPlateMask: {
      type: Object
    },

    transport: {
      type: Object,
      required: true
    },

    personalNationalities: {
      type: Array,
      default: () => []
    },

    personalIdentifications: {
      type: Array,
      default: () => []
    },

    nationalityDocuments: {
      type: Array,
      default: () => []
    },

    typeaheads: {
      type: Object,
      default: () => ({})
    },

    documentMasks: {
      type: Array,
      default: () => []
    },

    transportColors: {
      type: Array,
      default: () => [],
      required: true
    },

    transportDocuments: {
      type: [Object, Array],
      default: () => []
    },

    transportIndex: {
      type: Number,
      required: true
    },

    transportTypes: {
      type: Array,
      default: () => []
    },

    applicationPurposes: {
      type: [Array, Object],
      default: () => []
    },

    visitor: {
      type: Object,
      default: () => ({})
    },

    visitorIndex: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    idTransportMark: null,
    disabledNumberPlate: false
  }),

  computed: {
    PassSectionsEnum() {
      return PassSectionsEnum
    },

    TransportSectionFieldAliases() {
      return TransportSectionFieldAliases
    },

    organizationSubjectsWithoutFizAndTerminal() {
      return this.organizationSubjects.filter(
        organizationSubjet => organizationSubjet.id !== 'fiz' && organizationSubjet.id !== 'terminal'
      )
    },

    applicationPurpose() {
      return this.applicationPurposes[this.form.application.application_group_purpose_id]
    },

    transportOwnerInputStyles() {
      if (this.isPassKindTransport) {
        return !this.showTransportUserPosition ? ['col-md-12'] : ['col-md-8']
      }

      return ['col-md-12']
    },

    isSingleVisitor() {
      return this.transport.drivers.length === 1
    },

    isNotCutDriver() {
      if (this.isPassKindTransport) {
        return Number(this.configuration.cut_driver) === 0
      }

      return true
    },

    timezone() {
      return String(this.configuration.default_timezone ?? 'Europe/Moscow')
    },

    canRemoveTransport() {
      let access = this.terminalRegion?.transport_access
      let length = 0
      if (this.isPassKindTransport) {
        length = 1
      }

      return this.visitor.transports.length > length && this.isView === false && (
        access === undefined ||
        access === TerminalRegionActions.DEFAULT ||
        (
          access === TerminalRegionActions.AT_LEAST_ONE_TRANSPORT &&
          this.visitor.transports.length > 1
        )
      )
    },

    disabledColor() {
      return Boolean(this.disabledInput || this.transport.type === 'pedestrian')
    },

    disabledMark() {
      return Boolean(this.disabledInput || this.transport.type === 'pedestrian')
    },

    disabledModel() {
      return Boolean(this.disabledInput || ['pedestrian', 'bike'].includes(this.transport.type))
    },

    disabledStsType() {
      return Boolean(this.disabledInput || this.transport.type === 'pedestrian')
    },

    disabledNumber() {
      return Boolean(this.disabledInput || ['pedestrian', 'bike'].includes(this.transport.type)) ||
        Boolean(this.transport.number_missing)
    },

    disabledNumberHelpers() {
      return Boolean(this.disabledInput || ['pedestrian', 'bike'].includes(this.transport.type))
    },

    disabledOwner() {
      return Boolean(this.disabledInput || ['pedestrian', 'bike'].includes(this.transport.type))
    },

    disabledUserInput() {
      return Boolean(this.disabledInput)
    },

    disabledTrailer() {
      return Boolean(this.disabledInput || ['pedestrian', 'bike', 'trailer'].includes(this.transport.type))
    },

    disabledType() {
      return Boolean(this.disabledInput)
    },

    isTransportPedestrian() {
      return this.transport.type !== 'pedestrian'
    },

    sortedMarks() {
      if (this.isView) {
        return []
      }

      return this.$store.getters.transportMarks.filter(mark => mark.id_transport_kind === this.transport.type)
    },

    sortedModels() {
      const findMark = this.sortedMarks.find(mark => mark.name === this.transport.mark)

      if (this.transport.mark === undefined || findMark === undefined || this.isView) {
        return []
      }

      return this.$store.getters.transportModels.filter(model => model.id_transport_mark === findMark.id)
    },

    sortedStsTypes() {
      if (this.isView) {
        return []
      }

      return this.$store.getters.transportStsTypes.filter(stsType => stsType.id_transport_kind === this.transport.type)
    },

    sortedTrailerPlateMasks() {
      if (this.isView) {
        return [this.trailerPlateMask]
      }

      let masks = this.sortedPlateMask.trailerPlateMasks
      if (masks === undefined || masks.length === 0) {
        masks = [{ nationality_id: this.transport.trailer_nationality_id }]
      }

      return masks
    },

    sortedTransportPlateMasks() {
      if (this.isView) {
        return [this.transportPlateMask]
      }

      let masks = this.sortedPlateMask.transportPlateMasks?.filter(
        plateMask => plateMask.transport_type === this.transport.type
      )

      if (masks === undefined || masks.length === 0) {
        masks = [{ nationality_id: this.transport.number_nationality_id }]
      }

      return masks
    },

    showTransportUserPosition() {
      return this.isPassKindTransport && this.transport.drivers && this.transport.drivers.length === 0
    },

    showAddDriverButton() {
      let maxDriversCount = Number(this.configuration.form_drivers)
      if (!this.isView && maxDriversCount !== 0) {
        return this.transport?.drivers?.length < maxDriversCount
      }

      return false
    },

    trailerPlateMask() {
      return this.sortedPlateMask?.trailerPlateMasks?.find((plateMask) => {
        return Number(this.transport.trailer_nationality_id) === Number(plateMask.nationality_id)
      })
    },

    visibleCloseButton() {
      return Boolean(this.isView && this.user && this.cfgMenuVisitor.give_access_visitor)
    },

    transportFormMenuNotEmpty() {
      return this.visibleCloseButton ||
        this.visibleTransportPrintPassButton ||
        this.visibleTransportPrintPassPeriodButton ||
        this.visibleTransportPrintPassPermanentButton ||
        this.visibleTransportPrintPassPermanentAsOneButton || (
        this.isView && (
          this.visibleTransportIssuePassButton ||
          this.visibleTransportIssuePassPeriodButton ||
          this.visibleTransportSendToSolvoButton ||
          this.visibleTransportSendToScudButton
        )
      )
    },

    transportPlateMask() {
      return this.sortedPlateMask?.transportPlateMasks?.find((plateMask) => {
        return plateMask.transport_type === this.transport.type &&
          Number(this.transport.number_nationality_id) === Number(plateMask.nationality_id)
      })
    }
  },

  methods: {
    addVisitor() {
      const newVisitor = cloneObject(new Visitor())
      if (this.transport.drivers[0]) {
        newVisitor.personal.nationality_id = this.transport.drivers[0].personal.nationality_id
        newVisitor.personal.identification_id = this.transport.drivers[0].personal.identification_id
      }

      if (this.form.organization.subject_id === 'gko') {
        newVisitor.personal.identification_id = PersonalIdentifications.SERVICE_IDENTITY
      }
      this.transport.drivers.push(newVisitor)
      this.$emit('handle-terminal-region')
      this.scrollToLastVisitor()
    },

    removeVisitor(visitorIndex) {
      this.transport.drivers.splice(visitorIndex, 1)
      this.scrollToLastVisitor()
    },

    scrollToLastVisitor() {
      if (this.transport.drivers.length === 0) {
        return
      }

      this.$nextTick(() => {
        this.$scrollTo(
          '#' + this.transportDriverFormId(this.transport.drivers.length - 1),
          100,
          { offset: -90 }
        )
      })
    },

    transportDriverFormId(visitorIndex) {
      return `transport-${this.transport.index}-${visitorIndex}`
    },

    change() {
      this.$emit('change-transport', this.transport)
    },

    changeTrailerNationality(plate) {
      if (this.isView === false) {
        this.transport.trailer_nationality_id = plate.nationality_id
      }
    },

    changeTransportNationality(plate) {
      if (this.isView === false) {
        this.transport.number_nationality_id = plate.nationality_id
      }
    },

    checkMarkModel() {
      const mark = this.transport.mark
      const model = this.transport.model
      this.markModelError = false

      this.transport.errorMarkModel = !!(mark === model && mark && model)

      const visitors = this.form.visitors
      for (const visitor in visitors) {
        const transports = visitors[visitor].transports
        for (const transport of transports) {
          if (transport.errorMarkModel) {
            this.markModelError = true
            break
          }
        }

        if (this.markModelError) {
          break
        }
      }
    },

    clearMark() {
      const foundMark = this.$store.getters.transportMarks.find(
        mark => mark.id_transport_kind === this.transport.type && mark.name === this.transport.mark
      )

      this.transport.model = null
      if (foundMark === undefined) {
        this.transport.mark = null
      }
    },

    clearNumberPlateInput() {
      this.transport.number = null
      this.transport.trailer = null

      const foundNationalityPlate = this.sortedPlateMask.transportPlateMasks.find(
        plate => plate.nationality_id === this.transport.number_nationality_id &&
          plate.transport_type === this.transport.type
      )

      if (this.disabledTrailer) {
        this.transport.trailer_nationality_id = 182
      }

      if (!foundNationalityPlate) {
        this.transport.number_nationality_id = 182
      } else {
        this.transport.number_nationality_id = foundNationalityPlate.nationality_id
      }
    },

    removeRusInTransportNumber(isTrailer = false, event = null) {
      let transportNumber = null
      if (event) {
        transportNumber = (event.clipboardData || window.clipboardData).getData('text')
      } else {
        transportNumber = isTrailer ? this.transport.trailer : this.transport.number
      }

      if (transportNumber) {
        transportNumber = transportNumber.match(/[A-Za-zА-Яа-я0-9-]/g, '')
        transportNumber = transportNumber ? transportNumber.join('') : null

        if (transportNumber.substr(-3, 3).toLocaleLowerCase() === 'rus') {
          transportNumber = transportNumber.slice(0, -3)
        }

        if (isTrailer) {
          this.transport.trailer = transportNumber
        } else {
          this.transport.number = transportNumber
        }
      }

      if (isTrailer) {
        this.typingTransportNumber(true)
      } else {
        this.typingTransportNumber()
      }

      if (event) {
        event.preventDefault()
      }
    },

    removeTransport() {
      this.$emit('remove-transport', this.transportIndex)
    },

    selectTransportTypeahead(selected) {
      if (!(selected instanceof Object)) return

      this.transport.type = selected.type
      this.transport.sts_type = selected.sts_type
      this.transport.number = selected.number
      this.transport.mark = selected.mark
      this.transport.owner = selected.owner
      this.transport.color = selected.color
      this.transport.model = selected.model
      this.transport.trailer = selected.trailer

      this.typingTransportNumber(true)
      this.typingTransportNumber()
    },

    selectTypeaheadCar(item = null, isModel = false) {
      if (item === null) {
        if (isModel) {
          item = this.transport.model
        } else {
          item = this.transport.markData
        }
      }

      if (item instanceof Object) {
        if (isModel) {
          this.transport.model = item.name
        } else {
          this.idTransportMark = item.id
          this.transport.mark = item.name
        }
      }
    },

    setTransport(transport) {
      this.$emit('change-transport', transport)
    },

    onChangeNumberFieldPresenceType() {
      this.changeNumberPlate()

      let documentsToClean = this.transportDocuments.filter((item) => item.has_number !== null &&
        [this.form.application.terminal_region_id, null].includes(item.region_id) &&
        [this.transport.type, null].includes(item.transport_id))
      documentsToClean.forEach((item) => {
        if (this.transport.files[item.document.short_name]) {
          delete this.transport.files[item.document.short_name]
        }
      })
    },

    changeNumberPlate() {
      if (Boolean(this.transport.number_missing) === true) {
        this.transport.number = null
      }
    },

    async typeaheadCarNumber(query, done) {
      const transports = await Typeaheads.carNumber(query)
      done(transports.filter(transport => transport.number.toLowerCase().includes(this.transport.number.toLowerCase())))
    },

    async typeaheadColor(query, done) {
      done(await Typeaheads.carColor(query))
    },

    async typeaheadMark(query, done) {
      done(await Typeaheads.carMark(this.transport.type, query))
    },

    async typeaheadModel(query, done) {
      if (!this.idTransportMark) {
        return
      }

      done(await Typeaheads.carModel(this.idTransportMark, query))
    },

    async typeaheadTransportStsType(query, done) {
      done(await Typeaheads.transportStsType(this.transport.type, query))
    },

    typingTransportNumber(isTrailer = false) {
      const type = this.transport.type
      let transportNumber = this.transport.number
      if (isTrailer) {
        transportNumber = this.transport.trailer
      }

      if (transportNumber.length > 5) {
        ApiClient.validateTransportNumber(transportNumber).then(response => {
          const responseData = response.data
          const result = responseData.data

          if (result.country) {
            if (result.country.length === 1) {
              if (isTrailer) {
                if (result.transportType.length > 0 && result.transportType.includes('trailer')) {
                  this.transport.errorCountryTrailer = false
                  this.transport.trailerSVG = result.country[0]
                } else {
                  this.transport.trailerSVG = null
                  this.transport.errorCountryTrailer = true
                }
              } else {
                if (result.transportType.length > 0 && result.transportType[0] !== 'trailer') {
                  this.transport.countrySVG = result.country[0]
                  this.transport.errorCountry = false
                } else {
                  this.transport.countrySVG = null
                  this.transport.errorCountry = true
                }
              }

              if (result.transportType.length > 0 && !isTrailer && result.transportType[0] !== 'trailer') {
                if (result.transportType.length === 1) {
                  this.transport.type = result.transportType[0]
                } else {
                  if (result.transportType.length > 1) {
                    const ind = result.transportType.indexOf(type)
                    if (ind !== -1) {
                      this.transport.type = result.transportType[ind]
                    } else {
                      this.transport.type = result.transportType[0]
                    }
                  }
                }
              }
            } else {
              if (isTrailer) {
                this.transport.trailerSVG = null
                this.transport.errorCountryTrailer = true
              } else {
                this.transport.countrySVG = null
                this.transport.errorCountry = true
              }
            }
          }
        })
      } else {
        if (isTrailer) {
          this.transport.trailerSVG = null
          this.transport.errorCountryTrailer = false
        } else {
          this.transport.countrySVG = null
          this.transport.errorCountry = false
        }
      }

      this.checkMarkModel()
    }
  }
}
</script>
